export type Product = {
  id: number
  price: number
  purchase_daily_limit: number
}

export type UserPurchaseStats = {
  today_count: number
}

export type ExtraBoxOption = {
  productId: number
  price: number
  remaining: number
}

export type ExtraBoxes = {
  coin?: ExtraBoxOption
  gem?: ExtraBoxOption
  soldOut: boolean
}

export type DeriveExtraBoxesInput = {
  products: Product[]
  statsById: Record<number, UserPurchaseStats>
  coinBoxProductId: number
  gemBoxProductId: number
}

function buildOption(
  product: Product | undefined,
  stats: UserPurchaseStats | undefined,
): ExtraBoxOption | undefined {
  // Missing stats means the purchase-stats query hasn't resolved yet — keep
  // the option not-ready (UI shows the skeleton) instead of assuming zero
  // purchases, which would briefly enable the button at full `remaining` and
  // invite a 409 when the user is actually at the daily limit.
  if (!product || !stats) return undefined
  return {
    productId: product.id,
    price: product.price,
    remaining: Math.max(0, product.purchase_daily_limit - stats.today_count),
  }
}

export function deriveExtraBoxes(input: DeriveExtraBoxesInput): ExtraBoxes {
  const coin = buildOption(
    input.products.find((p) => p.id === input.coinBoxProductId),
    input.statsById[input.coinBoxProductId],
  )
  const gem = buildOption(
    input.products.find((p) => p.id === input.gemBoxProductId),
    input.statsById[input.gemBoxProductId],
  )
  const hasAny = coin !== undefined || gem !== undefined
  const allSold =
    (coin === undefined || coin.remaining === 0) &&
    (gem === undefined || gem.remaining === 0)
  return {
    coin,
    gem,
    soldOut: hasAny && allSold,
  }
}
